import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import stringify from '../utils/stableStringify';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import AntTime from '../utils/AntTime';
import Scheduler, { Resource, View } from 'devextreme-react/scheduler';
import DataSource from 'devextreme/data/data_source';

import { Template } from 'devextreme-react/core/template';
import AntConfig from '../utils/AntConfig';

import AntLocalization from '../utils/AntLocalization';
import AntCondition from '../utils/AntCondition';
import AntArray from '../utils/AntArray';
import { AntGlobal, AntSession } from '../utils/AntContext';

export default forwardRef(function (props, ref) {
    const appGlobal = AntGlobal();
    // const session = AntSession();
    const location = useLocation();
    const navigate = useNavigate();

    if (props.API && !props.API.entityDisplay) {
        if (appGlobal && appGlobal.appConfig && appGlobal.appConfig.Services) {
            let found = appGlobal.appConfig.Services.find((s) => s.name === props.API.entityName);
            if (found) props.API.init({ entityDisplay: found.display });
        }
    }

    const tableName = props.table ? props.table : props.API ? props.API.entityName : '';

    const config = useMemo(() => {
        let found = appGlobal.tableConfigs?.find((t) => t.tableName === tableName);
        if (found) return found.config;

        let cnf = new AntConfig(appGlobal, tableName);
        cnf.configFields(props.fields);

        if (appGlobal.tableConfigs instanceof Array === false) appGlobal.tableConfigs = [];

        appGlobal.tableConfigs.push({
            tableName: tableName,
            config: cnf
        });
        return cnf;
    }, []);

    const currentViews = useMemo(() => {
        let ar = [];
        if (props.views instanceof Array) {
            for (let i = 0; i < props.views.length; i++) {
                const view = props.views[i];

                var isValid = AntCondition.isValid(null, view.visible);
                if (isValid) {
                    ar.push({
                        ...(view && typeof view === 'object' ? view : {}),
                        type: view && typeof view === 'object' ? view.type : String(view),
                        name: view && typeof view === 'object' && view.name ? view.name : undefined
                    });
                }
            }
        }
        if (ar.length <= 0)
            ar = [
                { type: 'week', name: 'week' },
                { type: 'month', name: 'month' }
            ];
        return ar;
    }, props.views);

    const [currentView, setCurrentView] = useState(
        props.defaultCurrentView
            ? props.views.find(
                  (v) =>
                      v === props.defaultCurrentView ||
                      (v && typeof v === 'object' && (v.name === props.defaultCurrentView || v.type === props.defaultCurrentView))
              )
            : { type: 'week' }
    );

    const scheduler = useRef();
    const schedulerData = useRef();
    const schedulerResources = useRef([]);
    const isAppointmentCreating = useRef(false);

    const [hourRange, setHourRange] = useState({
        start: props.startDayHour ? props.startDayHour : 7,
        end: props.endDayHour ? props.endDayHour : 24
    });

    const forceRender = useCallback(() => {
        setShouldRender((v) => v + 1);
    }, []);

    const [shouldRender, setShouldRender] = useState(1);

    const isRender = useMemo(() => shouldRender + (props.shouldRender ? props.shouldRender : 1), [props.shouldRender, shouldRender]);

    const reload = useCallback(() => {
        if (scheduler.current && scheduler.current.instance) scheduler.current.instance.getDataSource().reload();
    }, []);

    const dateCellRender = useCallback((cellData) => {
        const dayOfWeekNames = [
            { vi: 'Chủ nhật', en: 'Sun', fr: 'Sun', es: 'Sun', id: 'Sun', ja: 'Sun', zh: 'Sun', ko: 'Sun', hi: 'Sun', ar: 'Sun' },
            { vi: 'Thứ hai', en: 'Mon', fr: 'Mon', es: 'Mon', id: 'Mon', ja: 'Mon', zh: 'Mon', ko: 'Mon', hi: 'Mon', ar: 'Mon' },
            { vi: 'Thứ ba', en: 'Tue', fr: 'Tue', es: 'Tue', id: 'Tue', ja: 'Tue', zh: 'Tue', ko: 'Tue', hi: 'Tue', ar: 'Tue' },
            { vi: 'Thứ tư', en: 'Wed', fr: 'Wed', es: 'Wed', id: 'Wed', ja: 'Wed', zh: 'Wed', ko: 'Wed', hi: 'Wed', ar: 'Wed' },
            { vi: 'Thứ năm', en: 'Thu', fr: 'Thu', es: 'Thu', id: 'Thu', ja: 'Thu', zh: 'Thu', ko: 'Thu', hi: 'Thu', ar: 'Thu' },
            { vi: 'Thứ sáu', en: 'Fri', fr: 'Fri', es: 'Fri', id: 'Fri', ja: 'Fri', zh: 'Fri', ko: 'Fri', hi: 'Fri', ar: 'Fri' },
            { vi: 'Thứ bảy', en: 'Sat', fr: 'Sat', es: 'Sat', id: 'Sat', ja: 'Sat', zh: 'Sat', ko: 'Sat', hi: 'Sat', ar: 'Sat' }
        ];
        let strText = AntLocalization.translateText(dayOfWeekNames[cellData.date.getDay()]);

        if (AntTime.isDateWithinToDay(cellData.date))
            strText = AntLocalization.translateText({ vi: 'Hôm nay', en: 'Today', fr: 'Aujourd\'hui', es: 'Hoy', id: 'Hari ini', ja: '今日', zh: '今天', ko: '오늘', hi: 'आज', ar: 'اليوم' });

        // if (AntTime.isDateWithinYesterday(cellData.date))
        //     strText = AntLocalization.translateText({
        //         vi: 'Hôm qua',
        //         en: 'Yesterday'
        //     });

        // if (AntTime.isDateWithinTomorrow(cellData.date))
        //     strText = AntLocalization.translateText({
        //         vi: 'Ngày mai',
        //         en: 'Tomorrow'
        //     });

        return (
            <div>
                <p
                    style={{
                        fontWeight: 400,
                        fontSize: '14px',
                        margin: 0
                    }}
                >
                    {strText}
                </p>
                <div
                    style={{
                        fontWeight: 400,
                        fontSize: '20px'
                    }}
                >
                    {cellData.date.getDate()}
                </div>
            </div>
        );
    }, []);

    const timeCellRender = useCallback((cellData) => {
        let localStr = AntLocalization.translateText({ vi: 'vi', en: 'en', fr: 'en', es: 'en', id: 'en', ja: 'en', zh: 'en', ko: 'en', hi: 'en', ar: 'en' });

        let b = new Date(cellData.date).toLocaleString(localStr, { hour: '2-digit', minute: '2-digit', hour12: true });

        return b;
    }, []);

    const dataCellRender = useCallback(
        (cell) => {
            let cssClasses = props.className ? props.className : '';

            if (!currentView || !currentView.groups || currentView.groupOrientation !== 'horizontal') {
                let isDay = AntTime.getIsoWeekday(cell.startDate);
                isDay = isDay % 2;

                if (AntTime.isDateWithinToDay(cell.startDate)) cssClasses += ' ant-scheduler-today-col';
                else {
                    if (isDay === 0) {
                        cssClasses += ' ant-scheduler-even-col';
                    } else cssClasses += ' ant-scheduler-odd-col';
                }
            }
            return <div className={cssClasses}>{props.children}</div>;
        },
        [props.className, props.children, currentView]
    );

    const getJoinSring = useCallback(
        (fields, data, type) => {
            var ar = [];

            if (fields instanceof Array) {
                var tableName = props.table ? props.table : props.API ? props.API.entityName : null;

                for (let i = 0; i < fields.length; i++) {
                    const fField = fields[i];

                    var found = config.getCnfField(fField, tableName);
                    if (found && found.cnfTable) found = config.getCnfField(found.cnfField, found.cnfTable ? found.cnfTable : tableName);

                    var valueField = found && found.lookup && found.lookup.valueField ? found.lookup.valueField : 'code';
                    var displayField = found && found.lookup && found.lookup.displayField ? found.lookup.displayField : 'name';
                    var lookupValues = found && found.lookup && found.lookup.values instanceof Array ? found.lookup.values : [];

                    var fValue = data[fField];
                    if (fValue != null) {
                        var obj = lookupValues.find((f) => f[valueField] === fValue);
                        if (obj) fValue = obj[displayField];
                    }

                    if (fValue instanceof Array) {
                        for (let j = 0; j < fValue.length; j++) {
                            let jValue = fValue[j];

                            jValue = AntLocalization.translateText(jValue);

                            if (typeof jValue === 'string') jValue = String(jValue);
                            if (jValue === null || jValue === undefined) jValue = '';
                            ar.push(jValue);
                        }
                    } else {
                        fValue = AntLocalization.translateText(fValue);

                        if (typeof fValue === 'string') fValue = String(fValue);
                        if (fValue === AntLocalization.translateText({ vi: 'Không', en: 'None', fr: 'Aucun', es: 'Ninguno', id: 'Tidak ada', ja: 'なし', zh: '无', ko: '없음', hi: 'कोई नहीं', ar: 'لا شيء' })) fValue = '';
                        if (fValue === null || fValue === undefined) fValue = '';
                        ar.push(fValue);
                    }
                }

                
                ar = AntArray.distinct(
                    ar
                        .flat()
                        .filter((f) => Boolean(f))
                        .map((f) => String(f))
                );
                if (type === 'first') return ar.length > 0 ? ar[0] : '';
            }
            return ar.join(props.joinSeparator ? props.joinSeparator : ', ');
        },
        [props.table, props.API, props.joinSeparator]
    );

    const appointmentRender = useCallback(
        (model) => {
            let localStr = AntLocalization.translateText({ vi: 'vi', en: 'en', fr: 'en', es: 'en', id: 'en', ja: 'en', zh: 'en', ko: 'en', hi: 'en', ar: 'en' });

            let data = model.appointmentData;
            let strTitle = props.textExpr ? data[props.textExpr] : data.text;
            let startDate = props.startDateExpr ? data[props.startDateExpr] : data.startDate;
            let endDate = props.endDateExpr ? data[props.endDateExpr] : data.endDate;

            // let strStartDate = new Date(startDate).toLocaleString(localStr, {
            //     month: 'long',
            //     day: 'numeric',
            //     hour: '2-digit',
            //     minute: '2-digit',
            //     hour12: true
            // });
            // let strEndDate = new Date(endDate).toLocaleString(localStr, {
            //     month: 'long',
            //     day: 'numeric',
            //     hour: '2-digit',
            //     minute: '2-digit',
            //     hour12: true
            // });

            let strStartDate = new Date(startDate).toLocaleString(localStr, {
                month: 'numeric',
                day: 'numeric'
            });
            if (props.startHourField && data[props.startHourField]) {
                let strStartDateTime = new Date(startDate).toLocaleString(localStr, {
                    hour: '2-digit',
                    minute: '2-digit'
                });
                strStartDate = strStartDateTime + ' ' + strStartDate;
            }

            let strEndDate = new Date(endDate).toLocaleString(localStr, {
                month: 'numeric',
                day: 'numeric'
            });
            if (props.endHourField && data[props.endHourField]) {
                let strEndDateDate = new Date(endDate).toLocaleString(localStr, {
                    hour: '2-digit',
                    minute: '2-digit'
                });
                strEndDate = strEndDateDate + ' ' + strEndDate;
            }

            let strDates = strStartDate;

            if (props.endDateField) strDates = strStartDate + (strEndDate ? ' - ' + strEndDate : '');

            let strDesc = props.descriptionExpr ? data[props.descriptionExpr] : '';
            if (props.descriptionFields instanceof Array && props.descriptionFields.length > 0) strDesc = getJoinSring(props.descriptionFields, data);

            let strTags = '';
            if (props.tagsFields instanceof Array && props.tagsFields.length > 0) strTags = getJoinSring(props.tagsFields, data, 'first');

            let strResouces = '';
            if (props.resourceFields instanceof Array && props.resourceFields.length > 0)
                strResouces = getJoinSring(props.resourceFields, data, props.resourceGenerateType ? props.resourceGenerateType : 'first');

            let isNewStatus = false;
            let isTodoStatus = false;
            let isDoingStatus = false;
            let isDoneStatus = false;
            if (props.isNewStatus) isNewStatus = props.isNewStatus(data);
            if (props.isTodoStatus) isTodoStatus = props.isTodoStatus(data);
            if (props.isDoingStatus) isDoingStatus = props.isDoingStatus(data);
            if (props.isDoneStatus) isDoneStatus = props.isDoneStatus(data);

            let className = '';
            if (isNewStatus) className = 'ant-appointment-new';
            if (isTodoStatus) className = 'ant-appointment-todo';
            if (isDoingStatus) className = 'ant-appointment-doing';
            if (isDoneStatus) className = 'ant-appointment-done';

            return (
                <div className={'ant-scheduler-appointment ' + className}>
                    {strTitle && <div className="ant-scheduler-appointment-title">{strTitle}</div>}
                    {strStartDate && !strDesc && <div className="ant-scheduler-appointment-time">{strDates}</div>}
                    {/* <div className="ant-scheduler-appointment-time">{strStartDate + (endDate ? ' - ' + strEndDate : '')}</div> */}
                    {strDesc && <div className="ant-scheduler-appointment-desc">{strDesc}</div>}
                    {strTags && <div className="ant-scheduler-appointment-tags">{strTags}</div>}
                    {strResouces && <div className="ant-scheduler-appointment-resources">{strResouces}</div>}
                </div>
            );
        },
        [
            props.textExpr,
            props.startDateExpr,
            props.endDateExpr,
            props.startHourField,
            props.endHourField,
            props.endDateField,
            props.descriptionExpr,
            props.descriptionFields,
            props.tagsFields,
            props.resourceFields,
            props.resourceGenerateType,
            props.isNewStatus,
            props.isTodoStatus,
            props.isDoingStatus,
            props.isDoneStatus
        ]
    );

    const onOptionChanged = useCallback(
        (e) => {
            if (e.name === 'currentView') {
                let cView = currentViews.find((v) => v === e.value || (v && typeof v === 'object' && (v.name === e.value || v.type === e.value)));
                setCurrentView(cView);
                if (props.onViewChanged) props.onViewChanged(e.value);
            }
            if (e.name === 'currentDate') {
                if (props.onDateChanged) props.onDateChanged(e.value);
            }
        },
        [props.onViewChanged, currentViews]
    );

    const customizeDateNavigatorText = useCallback(
        (e) => {
            let localStr = AntLocalization.translateText({ vi: 'vi', en: 'en', fr: 'en', es: 'en', id: 'en', ja: 'en', zh: 'en', ko: 'en', hi: 'en', ar: 'en' });

            if (currentView && ['month'].includes(currentView.type))
                return e.startDate.toLocaleString(localStr, { year: 'numeric', month: 'numeric' });

            const formatOptions = {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
            };
            let formattedStartDate = e.startDate.toLocaleString(localStr, formatOptions);
            let formattedEndDate = e.endDate.toLocaleString(localStr, formatOptions);

            if (AntTime.isDateWithinToDay(e.startDate))
                formattedStartDate = AntLocalization.translateText({ vi: 'Hôm nay', en: 'Today', fr: 'Aujourd\'hui', es: 'Hoy', id: 'Hari ini', ja: '今日', zh: '今天', ko: '오늘', hi: 'आज', ar: 'اليوم' });
            else if (AntTime.isDateWithinYesterday(e.startDate))
                formattedStartDate = AntLocalization.translateText({ vi: 'Hôm qua', en: 'Yesterday', fr: 'Hier', es: 'Ayer', id: 'Kemarin', ja: '昨日', zh: '昨天', ko: '어제', hi: 'कल (बीता)', ar: 'أمس' });
            else if (AntTime.isDateWithinTomorrow(e.startDate))
                formattedStartDate = AntLocalization.translateText({ vi: 'Ngày mai', en: 'Tomorrow', fr: 'Demain', es: 'Mañana', id: 'Besok', ja: '明日', zh: '明天', ko: '내일', hi: 'कल (आने वाला)', ar: 'غداً' });
            else if (e.startDate.getFullYear() === e.endDate.getFullYear() && e.startDate.getFullYear() === new Date().getFullYear())
                formattedStartDate = e.startDate.toLocaleString(localStr, { day: 'numeric', month: 'numeric' });

            if (AntTime.isDateWithinToDay(e.endDate))
                formattedEndDate = AntLocalization.translateText({ vi: 'Hôm nay', en: 'Today', fr: 'Aujourd\'hui', es: 'Hoy', id: 'Hari ini', ja: '今日', zh: '今天', ko: '오늘', hi: 'आज', ar: 'اليوم' });
            else if (AntTime.isDateWithinYesterday(e.endDate))
                formattedEndDate = AntLocalization.translateText({ vi: 'Hôm qua', en: 'Yesterday', fr: 'Hier', es: 'Ayer', id: 'Kemarin', ja: '昨日', zh: '昨天', ko: '어제', hi: 'कल (बीता)', ar: 'أمس' });
            else if (AntTime.isDateWithinTomorrow(e.endDate))
                formattedEndDate = AntLocalization.translateText({ vi: 'Ngày mai', en: 'Tomorrow', fr: 'Demain', es: 'Mañana', id: 'Besok', ja: '明日', zh: '明天', ko: '내일', hi: 'कल (आने वाला)', ar: 'غداً' });
            else if (e.startDate.getFullYear() === e.endDate.getFullYear() && e.startDate.getFullYear() === new Date().getFullYear())
                formattedEndDate = e.endDate.toLocaleString(localStr, { day: 'numeric', month: 'numeric' });

            if (formattedStartDate === formattedEndDate) {
                return formattedStartDate;
            }

            return formattedStartDate + ' - ' + formattedEndDate;
        },
        [currentView]
    );

    const onAppointmentClick = useCallback(
        (e) => {
            e.cancel = true;
            if (props.onAppointmentClick) props.onAppointmentClick(e.appointmentData);
        },
        [props.onAppointmentClick]
    );

    const initResources = useCallback(() => {
        let ar = [];

        if (props.resources instanceof Array && props.resources.length > 0) {
            if (schedulerData.current instanceof Array) {
                for (var i = 0; i < props.resources.length; i++) {
                    let values = schedulerData.current.map((v) => v[props.resources[i].valueExpr]);
                    values = AntArray.distinct(values).filter((v) => v !== null && v !== undefined);
                    values = values.map((v) => {
                        return { [props.resources[i].valueExpr]: v };
                    });

                    ar.push({
                        fieldExpr: props.resources[i].fieldExpr,
                        displayExpr: props.resources[i].displayExpr,
                        valueExpr: props.resources[i].valueExpr,
                        label: props.resources[i].label,
                        dataSource: values
                    });
                }
            }
        }
        return ar;
    }, [props.resources]);

    const onLoadData = useCallback(
        async (data) => {
            let arData = data.data;

            if (props.customData) arData = props.customData(arData);

            schedulerData.current = arData;
            let newResources = initResources();
            if (stringify(schedulerResources.current).trim() !== stringify(newResources).trim()) {
                schedulerResources.current = newResources;
                forceRender();
            }

            var minHour = props.startDayHour ? props.startDayHour : 7;
            var maxHour = props.endDayHour ? props.endDayHour : 24;

            let ar = arData;
            ar = ar.filter((a) => a[props.startHourField]);
            if (ar.length > 0) {
                ar = ar.map((a) => AntTime.init(a[props.startHourField]).unix());

                minHour = Math.min.apply(Math, ar);
                maxHour = Math.max.apply(Math, ar);

                minHour = AntTime.newDateAndTime(minHour, minHour).hour();
                maxHour = AntTime.newDateAndTime(maxHour, maxHour).hour();

                minHour = minHour - 1;
                maxHour = maxHour + 2;
            }

            if (maxHour <= minHour + 5) maxHour = minHour + 5;

            if (!minHour) minHour = props.startDayHour ? props.startDayHour : 7;
            if (!maxHour || maxHour > 24) minHour = props.endDayHour ? props.endDayHour : 24;

            setHourRange({
                start: props.startDayHour && hourRange.start && hourRange.start < minHour ? hourRange.start : minHour,
                end: props.endDayHour && hourRange.end && hourRange.end > maxHour ? hourRange.end : maxHour
            });
        },
        [props.customData, initResources, props.startDayHour, props.endDayHour, props.startHourField, forceRender]
    );

    const onCellClick = useCallback(
        async (e) => {
            let cellData = e.appointmentData;

            if (props.onAdding) props.onAdding(cellData);

            if (props.API && props.creation && props.creation.appointmentField) {
                let dateUnix = AntTime.init(cellData.startDate).unix();

                delete cellData.allDay;
                delete cellData.startDate;
                delete cellData.endDate;

                var result = await props.API.postQuickCreate({ ...cellData, [props.creation.appointmentField]: dateUnix });
                if (result && !result.error) {
                    if (result.data) {
                        var code = result.data.code;
                        var id = result.data.id;

                        if (props.creation && props.creation.navigateLink && result.data) {
                            var value;
                            var link;

                            var that = this;
                            if (props.creation.navigateLink instanceof Array) {
                                props.creation.navigateLink.forEach((l) => {
                                    if (l && l.link) {
                                        if (l.when && typeof l.when === 'object') {
                                            var isValid = AntCondition.isValid(result.data, {
                                                when: l.when,
                                                whenType: l.whenType
                                            });
                                            if (!isValid) return;
                                        }
                                        value = l.field ? result.data[l.field] : result.data.code;
                                        link = String(l.link);
                                    }
                                });
                            } else {
                                value = props.creation.navigateField ? result.data[props.creation.navigateField] : result.data.code;
                                link = String(props.creation.navigateLink);
                            }
                            if (link && value !== undefined && value !== null) {
                                if (!link.startsWith('/')) link = '/' + link;
                                if (!link.endsWith('/')) link = link + '/';
                                link = link + value;
                                navigate(link);
                            }
                        }
                    }
                }
            }
        },
        [props.onAdding, props.API, props.creation]
    );

    const onAppointmentRendered = useCallback(
        (e) => {
            let cView = e.component.option('currentView');
            cView = currentViews.find((v) => v.name === cView || v.type === cView);
            if (cView) cView = cView.type;

            if (['day', 'week', 'workWeek', 'month'].includes(cView)) {
                const width = e.element.querySelector('.dx-scheduler-date-table-cell').clientWidth - 8; // get a cell's width
                const height = e.element.querySelector('.dx-scheduler-date-table-cell').clientHeight * 2 - 4; // get a cell's width
                e.appointmentElement.style.width = `${width}px`;

                if (!props.endDateField || !e.appointmentData[props.endDateField]) e.appointmentElement.style.height = `${height}px`;
            }

            // if (['day', 'week', 'workWeek', 'month'].includes(cView))
        },
        [currentViews, props.endDateField]
    );

    const onAppointmentFormOpening = useCallback(
        async (e) => {
            e.cancel = true;

            if (!isAppointmentCreating.current) {
                isAppointmentCreating.current = true;
                await onCellClick(e);
                isAppointmentCreating.current = false;
            }
        },
        [onCellClick]
    );

    useImperativeHandle(ref, () => ({
        reload: reload,
        onLoadData: onLoadData
    }));

    return (
        <React.Fragment>
            {isRender && (
                <Scheduler
                    ref={scheduler}
                    {...props}
                    dataSource={props.dataSource}
                    startDateExpr={props.startDateExpr}
                    endDateExpr={props.endDateExpr}
                    showAllDayPanel={true}
                    textExpr={props.textExpr}
                    descriptionExpr={props.descriptionExpr}
                    startDayHour={hourRange.start}
                    endDayHour={hourRange.end}
                    views={currentViews}
                    currentView={
                        currentView && currentView.name
                            ? currentView.name
                            : currentView && currentView.type
                            ? currentView.type
                            : props.defaultCurrentView
                    }
                    onOptionChanged={onOptionChanged}
                    customizeDateNavigatorText={customizeDateNavigatorText}
                    defaultCurrentDate={props.defaultCurrentDate ? props.defaultCurrentDate : AntTime.now().toDate()}
                    height={'100%'}
                    editing={{
                        allowAdding: true,
                        allowDeleting: false,
                        allowResizing: false,
                        allowDragging: false,
                        allowUpdating: false
                    }}
                    // crossScrollingEnabled={true}
                    allDayPanelMode={'hidden'}
                    cellDuration={props.cellDuration ? props.cellDuration : 30}
                    showCurrentTimeIndicator={props.showCurrentTimeIndicator}
                    shadeUntilCurrentTime={props.shadeUntilCurrentTime}
                    onAppointmentRendered={onAppointmentRendered}
                    onAppointmentFormOpening={onAppointmentFormOpening}
                    dateCellTemplate={'dateCellRender'}
                    // timeCellTemplate={'timeCellRender'}
                    dataCellTemplate={'dataCellRender'}
                    appointmentTemplate={'appointmentRender'}
                    // scrolling={{ mode: 'virtual' }}
                    onAppointmentClick={onAppointmentClick}
                    resources={schedulerResources.current}
                    groups={props.groups}
                >
                    <Template name={'dateCellRender'} render={dateCellRender} />
                    <Template name={'timeCellRender'} render={timeCellRender} />
                    <Template name={'dataCellRender'} render={dataCellRender} />
                    <Template name={'appointmentRender'} render={appointmentRender} />
                </Scheduler>
            )}
        </React.Fragment>
    );
});
